export const CABINET_TYPES = {
  FLAT_PACK: 'flat-pack',
  PRE_BUILT: 'pre-built',
}

export const UNIT_TYPE = {
  small: 0,
  medium: 1,
  large: 2,
  xlarge: 3,
}
